import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VerticalLabelList from '../../label/VerticalLabelList';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import ObjectUtils from '../../../modules/ObjectUtils';

const EbillingEnrollmentDetail = ({ selectedAccount, }) => {
  const renderAccountData = () => {
    const formattedAccount = Object.keys(selectedAccount)
      .filter(key => !!selectedAccount[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = selectedAccount[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedAccount);
    const exclusions = [ 'Client Data', 'Water Account Payments', ];

    return (
      <FieldSet title="Account Data" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const renderClientData = () => {
    const clientData = selectedAccount.clientData || {};
    const formattedAccount = Object.keys(clientData)
      .filter(key => !!clientData[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = clientData[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedAccount);
    const exclusions = [];

    return (
      <FieldSet title="Client Data" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const formatMoney = (money) => {
    return `${parseFloat(money.amount).toFixed(2)} ${money.currencyCode}`;
  };

  const formatTransactions = (paymentTransactions = []) => {
    return paymentTransactions.map((value) => {
      const ref = { ...value, };
      ref.paymentAmount = value.paymentAmount
        ? formatMoney(value.paymentAmount)
        : '';
      return ref;
    });
  };

  const renderAccountTransactions = () => {
    const { waterAccountPayments = [], } = selectedAccount;
    const paymentExclusions = [ 'clientSnapshotData', ];
    const paymentTransactionsJson = ObjectUtils.formatStringAsJSONArray(waterAccountPayments);
    const transactionModel = Grid.toModelFromList(paymentTransactionsJson, {
      headerFormatter: (value) => _.startCase(value.header),
      filter: (value) => !paymentExclusions.includes(value),
    });

    return (
      <FieldSet title='Payment Transactions'>
        <Grid
          headers={transactionModel.headers}
          rows={transactionModel.format(
            formatTransactions(paymentTransactionsJson)
          )}
        />
      </FieldSet>
    );
  };

  return (
    <>
      {renderAccountData()}
      {renderClientData()}
      {renderAccountTransactions()}
    </>
  );
};

EbillingEnrollmentDetail.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default EbillingEnrollmentDetail;
